<div class="container-fluid">
  <div class="form-horizontal">
    <h3>{{ 'events.settings.benefits.title' | translate | titlecase }}</h3>
    <p [hidden]="!showBenefitHelp" class="text-danger">
      {{ 'benefits.messages.no-benefit-codes-1' | translate }}
      <a href="https://support.weblinkinternational.com/hc/en-us/articles/115006207288" target="_blank">{{
        'benefits.messages.no-benefit-codes-2' | translate
      }}</a>
      {{ 'benefits.messages.no-benefit-codes-3' | translate }}
    </p>

    <div class="row form-row">
      <div class="col-sm-12">
        <div [hidden]="!_error" class="text-danger">{{ _error }}</div>

        <button app-add-button
          [disabled]="_loadingAssets"
          [label]="('common.add' | translate | titlecase) + ' ' + ('events.settings.benefits.benefit-label' | translate | titlecase)"
          (onClick)="newEventBenefit()"
        >
        </button>
      </div>
    </div>

    <div class="row form-row">
      <div class="col-sm-12">
        <wl-busy *ngIf="loadingBenefits" [show]="loadingBenefits"></wl-busy>
        <p-table [showGridlines]="true" #benefitsDataGrid [rows]="100" [value]="eventBenefits" [hidden]="loadingBenefits">
          <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
            <SortAltIcon *ngIf="sortOrder === 0">
              <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
            </SortAltIcon>
            <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
              <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
            </SortAmountUpAltIcon>
            <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
              <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
            </SortAmountDownIcon>
          </ng-template>
          <ng-template pTemplate="header">
            <tr>
              <th>
                {{ 'events.settings.benefits.benefit-label' | translate | titlecase }}
                {{ 'common.personal-information.name' | translate | titlecase }}
              </th>
              <th></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-dataItem>
            <tr>
              <td>{{ dataItem.BenefitType }}</td>
              <td>
                <button
                  pButton
                  type="button"
                  class="btn btn-default"
                  (click)="editEventBenefit(dataItem)"
                  [disabled]="_loadingAssets"
                  icon="pi pi-pencil"
                >
                  {{ 'common.edit' | translate | titlecase }}
                </button>
                <button pButton type="button" class="btn btn-danger" (click)="deleteEventBenefit(dataItem)" icon="pi pi-trash">
                  {{ 'common.delete' | translate | titlecase }}
                </button>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>

<p-dialog
  #editEventBenefitModal
  [(visible)]="showModal"
  [closable]="false"
  styleClass="atlas-dialog-s"
  [focusOnShow]="false"
  [contentStyle]="{ 'max-height': '75vh' }"
>
  <ng-template pTemplate="header">
    <strong *ngIf="selectedEventBenefit.EventBenefitId == 0"
      >{{ 'common.new' | translate | titlecase }} {{ 'events.settings.benefits.benefit-label' | translate | titlecase }}</strong
    >
    <strong *ngIf="selectedEventBenefit.EventBenefitId > 0"
      >{{ 'common.edit' | translate | titlecase }} {{ 'events.settings.benefits.benefit-label' | translate | titlecase }}</strong
    >
  </ng-template>
  <div class="container-fluid">
    <div class="form-horizontal">
      <div class="form-group">
        <label class="control-label col-sm-3">
          {{ 'benefits.profile-benefit-mgt.benefit-label' | translate | titlecase }}
        </label>
        <div class="col-sm-9">
          <div [hidden]="benefitTypes && benefitTypes.length">{{ 'benefits.profile-benefit-mgt.no-event-benefit-types' | translate }}</div>

          <select
            [(ngModel)]="selectedEventBenefit.BenefitTypeId"
            [hidden]="!benefitTypes || !benefitTypes.length"
            class="form-control"
            (ngModelChange)="onBenefitTypeChange($event)"
          >
            <option
              *ngFor="let benefit of benefitTypes"
              [value]="benefit.Id"
              [selected]="benefit.Id == selectedEventBenefit.BenefitTypeId ? true : null"
            >
              {{ benefit.Name }}
            </option>
          </select>
        </div>
      </div>

      <div class="form-group">
        <label class="control-label col-sm-3">
          {{ 'events.settings.benefits.benefit-limit-type' | translate | titlecase }}
        </label>
        <div class="col-sm-4">
          <div class="form-control-static">
            <label>
              <input type="radio" name="eventBenefitDiscoutType" [value]="0" [(ngModel)]="selectedEventBenefit.LimitType" />
              {{ 'events.settings.benefits.limit-type-dollar-value-label' | translate | titlecase }}
            </label>
            <label>
              <input type="radio" name="eventBenefitDiscoutType" [value]="1" [(ngModel)]="selectedEventBenefit.LimitType" />
              {{ 'events.settings.benefits.limit-type-quanity-label' | translate | titlecase }}
            </label>
          </div>
        </div>
      </div>

      <div class="form-group">
        <label class="control-label col-sm-3">
          {{ 'events.settings.benefits.benefit-limit-per-member' | translate | titlecase }}
        </label>
        <div class="col-sm-4">
          <div class="input-group">
            <span class="input-group-addon" [hidden]="selectedEventBenefit.LimitType != 0">$</span>
            <input type="number" class="form-control" [(ngModel)]="selectedEventBenefit.LimitAmount" min="0.00" step="1" />
          </div>
        </div>
      </div>

      <div class="form-group">
        <label class="control-label col-sm-3">
          {{ 'common.revenue.adjustment' | translate | titlecase }} {{ 'common.type' | translate | titlecase }}
        </label>
        <div class="col-sm-9">
          <select [(ngModel)]="selectedEventBenefit.AdjustmentTypeId" class="form-control" (ngModelChange)="onAdjustmentTypeChange($event)">
            <option
              *ngFor="let adjType of adjustmentTypes"
              [value]="adjType.AdjustmentTypeId"
              [selected]="adjType.AdjustmentTypeId == selectedEventBenefit.AdjustmentTypeId ? true : null"
            >
              {{ adjType.AdjustmentType }}
            </option>
          </select>
        </div>
      </div>
      <div class="form-group">
        <label class="control-label col-sm-3">{{ 'events.settings.benefits.event-item-label' | translate | titlecase }}</label>
        <div class="col-sm-9">
          <div *ngFor="let eventItem of selectedEventBenefit.EventItems">
            <label class="col-sm-6">
              <input type="checkbox" [(ngModel)]="eventItem.Selected" />
              {{ eventItem.EventPriceDescr }}
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <wl-busy *ngIf="isSaving" [show]="isSaving"></wl-busy>
    <button pButton type="button" class="btn btn-primary" [disabled]="isSaving" (click)="saveEventBenefit()" icon="pi pi-save">
      <span [hidden]="isSaving">{{ 'common.save' | translate | titlecase }}</span>
      <span [hidden]="!isSaving">{{ 'common.saving' | translate | titlecase }}</span>
    </button>
    <button pButton type="button" class="btn btn-secondary" [disabled]="isSaving" (click)="editEventBenefitModal.close()" icon="pi pi-ban">
      {{ 'common.cancel' | translate | titlecase }}
    </button>
  </ng-template>
</p-dialog>
